import { render, staticRenderFns } from "./shopSplitHistList.vue?vue&type=template&id=33580adb&scoped=true"
import script from "./shopSplitHistList.vue?vue&type=script&lang=js"
export * from "./shopSplitHistList.vue?vue&type=script&lang=js"
import style0 from "./shopSplitHistList.vue?vue&type=style&index=0&id=33580adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33580adb",
  null
  
)

export default component.exports